import axios from 'axios';
import Config from 'Config';
import { createSignedRequest } from 'utils/createSignedRequest';
import { API_URL } from '../utils/constants';

export const patchFloorplanPlacement = async (
  projectId,
  placementId,
  updateParams
) => {
  const apiPath = `projects/${projectId}/floorplan-placements/${placementId}`;

  const request = {
    url: `${API_URL}/${apiPath}`,
    host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
    path: apiPath,
    method: 'PATCH',
    region: Config.AWS_REGION,
    service: 'execute-api',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(updateParams),
    data: updateParams,
  };

  const signedRequest = await createSignedRequest(request);
  const response = await axios(signedRequest);
  return response.data;
};
